async function getResponse(url: string, options?: RequestInit): Promise<Response> {
	let response: Response;
	try {
		response = await fetch(url, options);
	} catch(error:any) {
		throw Error(error);
	}

	if(response.ok)
	{
		return response;
	}	else {
		throw Error(await response.text())
	}
}

export default function useFetcher() {
	const fetcher = async (url: string, options?: RequestInit) => {
		try {
			const response = await getResponse(url, options);
			return await response.json();
		} catch(error:any) {
			throw error;
		}
	};

	const blobFetcher = async (url: string, options?: RequestInit) => {
		try {
			const response = await getResponse(url, options);

			return await response.blob();
		} catch(error:any) {
			throw error;
		}
	};

	return {
		fetcher,
		blobFetcher,
	};
}
